import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { observer } from 'mobx-react-lite';
import { go } from "routes/index";
import CtaButton from 'components/CtaButton/index';
import styles from './servicedetail.module.css';
import styled from 'styled-components';
import { capitalise } from 'libs/misc';
import { useAppointmentStore } from 'store/mobx/mobx'
import { bindActionCreators } from 'redux';
import { actions as loginActions } from "../../EntryPage/actions/actions";
import { actions as feelingActions } from '../Reason/actions/actions';
import Header from "components/UIContainer/MobileUI/header/index";
import LoadingSpinner from 'components/loadingSpinner/index';
import { isDesktop } from "config";

const PageContainer = styled.div`
`
const ServiceHeader = styled.h3`
`
const InfoContainer = styled.div`
`
const NotUser = styled.div`
`

const ServiceDetail = observer(
    ({
      token,
      consultationMethods,
      profile,
      logout,
      practice,
      sessionDetails,
      updateSession
    }) => {

  const store = useAppointmentStore();
  let history = useHistory();

  const { id, serviceId } = useParams();
  const firstName = profile.FirstName;

  const handleLogOut = () => {
    logout(token);
    go.loginTriage(id);
  };

  useEffect(() => {
    if (!store.receivedServiceQuestionnaire || store.getSelectedService()?.Id !== serviceId) store.getServiceQuestionnaire(id, serviceId);
  },[id, serviceId, store])

  const handleCtaClick = () => {
    if (store.ServiceQuestionnaire.QuestionnaireQuestions && store.ServiceQuestionnaire.QuestionnaireQuestions.length > 0) {
      go.questionnaire(id, consultationMethods)
    } else {
      const symptomIds = [];
      // Continue booking appointment
      updateSession(
        sessionDetails.SessionId,
        'selectMethod',
        symptomIds,
        'note',
        {
          Id: serviceId,
          Name: store.ServiceQuestionnaire.ServiceName,
          Description: store.ServiceQuestionnaire.ServiceName
        },
        practice.UrlName,
      );
    }
  };

  return (
    <LoadingSpinner
      isFetching={!store.receivedServiceQuestionnaire}
      containerClassName={styles.outerContainer}
      iconClassName={styles.spinner}
      overlayClassName={styles.overlay}
    >    
      <PageContainer className={styles.pageContainer}>
        {!isDesktop() && <Header goBackFn={() => history.goBack()} headerClassNames={styles.header} showHelp />}
        <ServiceHeader className={styles.serviceHeader}>{store.ServiceQuestionnaire.ServiceName}</ServiceHeader>
        <InfoContainer className={styles.infoContainer}>
        {store.ServiceQuestionnaire.Description.map((section, index) => (
          <div key={index} style={{ marginBottom: '20px' }}>
            {section.Heading && <h3 className={styles.paragraphHeader}>{section.Heading}</h3>}
            {section.Lines.map((line, lineIndex) => (
              <p key={lineIndex}>{line}</p>
            ))}
          </div>
        ))}
        </InfoContainer>
        <CtaButton
          className={styles.cta}
          onClick={handleCtaClick}
          active={true}
        />
        <NotUser className={styles.notUser}>
          <div className={styles.logoutText} onClick={handleLogOut}>
            <div className={styles.notUserText}>{`Not ${capitalise(firstName)}?`}</div>
            <div>Log out</div>
          </div>
        </NotUser>
      </PageContainer>
    </LoadingSpinner>
  );
});

const mapStateToProps = state => ({
    token: state.loginReducer.token,
    profile: state.profileReducer.profile,
    practice: state.practiceProfileReducer.profile,
    sessionDetails: state.checkEnrollmentReducer.session,
});
  
const mapDispatchToProps = dispatch => ({
  updateSession: bindActionCreators(feelingActions.updateSession, dispatch),
  logout: bindActionCreators(loginActions.logout, dispatch),
});
  
export default connect(mapStateToProps, mapDispatchToProps)(ServiceDetail);
